<script>
import { MapAgentStationStatus, MapRoles } from "@/common/util";
import PagenationContainer from "@/components/common/PagenationContainer.vue";

import cloneDeep from "lodash/cloneDeep";
import forOwn from "lodash/forOwn";
import moment from "moment";
export default {
  components: {
    PagenationContainer
  },
  data() {
    return {
      tabPosition: "factory",
      agentName: '',
      searPlaceholder: '经手人',
      tableDataAgent: [],
      tableDataStation: [],
      tableDataFactory: [],
      achievementData: {
        remainingTreatmentCount: undefined,
        sales: undefined,
        targetCount: undefined
      },
      defaultValue: {},
      agentList: [],
      pageCount: 0,
      activePage: 1,
      totalElements: 0,
      dateRange: [],
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    async loadData() {
      const stats = await this.$http.getAgentAchievementStatistic();
      if (stats) {
        this.achievementData = stats;
      }
      
      let params = {
        page: this.activePage - 1
      };
      console.log("tab position:" + this.tabPosition);
      if (this.tabPosition == 'factory') {
        this.searPlaceholder = '经手人';
        const agentId = this.$cookie.get('id');
        if (this.dateRange.length>0) {
          params.start = this.dateRange[0];
          params.end = this.dateRange[1];
        }
        params.agentId=agentId;
        params.name=this.agentName
        const result = await this.$http.findAgentPurchase(params);
        if (result && result.content) {
          this.pageCount = result.totalPages;
          this.totalElements = result.totalElements;
          this.tableDataFactory = result.content;
        }
      } else if (this.tabPosition == 'agent') {
        this.searPlaceholder = '购买单位';
        if (this.dateRange.length>0) {
          params.beginTime = this.dateRange[0] + ' 00:00:00';
          params.endTime = this.dateRange[1] + ' 23:59:59';
        }
        params.buyerCompanyName = this.agentName
        const result = await this.$http.getTallyBookAgent(params);
        if (result && result.content) {
          this.pageCount = result.totalPages;
          this.totalElements = result.totalElements;
          this.tableDataAgent = result.content;
        }
      } else {
        this.searPlaceholder = '购买单位';
        if (this.dateRange.length>0) {
          params.beginTime = this.dateRange[0] + ' 00:00:00';
          params.endTime = this.dateRange[1] + ' 23:59:59';
        }
        params.stationName=this.agentName;
        const result = await this.$http.getTallyBookStation(params);
        if (result && result.content) {
          this.pageCount = result.totalPages;
          this.totalElements = result.totalElements;
          this.tableDataStation = result.content;
        }
      }
    },
    async handChange(val) {
      this.activePage = 1;
      this.agentName = '';
      this.loadData();
    },
    handleCurrentChange(val) {
      this.activePage = val;
      this.loadData();
    },

    dateFormatter(row, column) {
      return moment(row.createdAt).format('YYYY-MM-DD HH:mm:ss');
    },

    opTypeFormatter(row, column) {
      return row.operateType === 'PAY' ? "进货" : "退货";
    },
    recordTypeFormatter(row, column) {
      return row.recordType === 'REFUND' ? "退货" : "进货";
    },
    totalValueFormatter(row, column) {
      return row.courseCount * row.unitPrice * (row.operateType == 'PAY' ? 1 : -1);
    },
    totalFormatter(row, column) {
      return row.quantity * row.unitPrice * (row.recordType == 'REFUND' ? -1 : 1);
    },
    salesType(row, column) {
      return row.singleSales || row.single ? "单次" : "疗程";
    }
  }
};
</script>
<template>

  <div class="agentPurchaseHistoryIndex">
    <div>
      <div class="targetView">
        <div class="searchLocation">
          <div>
            <div class="saleNumberTitle">业绩目标</div>
            <div
              class="saleNumber"
            >{{achievementData.sales || '--'}}/{{achievementData.targetCount || '--'}}疗程</div>
          </div>
          <div class="line"></div>
          <div>
            <div class="saleNumberTitle">剩余疗程/单次训练</div>
            <div class="saleNumber">{{achievementData.remainingTreatmentCount || '--'}}疗程/{{ achievementData.remainingSingleCount }}次</div>
          </div>
          <div>
            <el-tag
              v-if="achievementData.remainingTreatmentCount && achievementData.remainingTreatmentCount < 100"
              size="mini"
              type="danger"
            >即将售罄</el-tag>
          </div>
        </div>
      </div>
      <div class="TextGroup">
        <div class="dataSearch">
          <span>销售疗程时间筛选：</span>
          <el-date-picker
            v-model="dateRange"
            size="medium"
            class="dateRange"
            type="daterange"
            range-separator="至"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="loadData"
          ></el-date-picker>
          <el-input type="text" :placeholder="searPlaceholder" class="dateRange" style="height:36px" v-model="agentName" ></el-input>
          <el-button @click="loadData" type="primary" class="submitButton">搜索</el-button>
        </div>
      </div>
    </div>
    <el-radio-group v-model="tabPosition" style="margin: 30px 28px" @change="handChange">
      <el-radio-button label="factory">厂家</el-radio-button>
      <el-radio-button label="agent">代理商</el-radio-button>
      <el-radio-button label="station">医疗机构</el-radio-button>
    </el-radio-group>
    <div class="statistics">
      <i class="el-icon-info totalResult"></i>
      查询结果：
      <span class="totalResult">{{totalElements}}</span> 个
    </div>
    <el-table
      v-if="tabPosition == 'factory'"
      :data="tableDataFactory"
      class="refundTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column :formatter = "dateFormatter" align="left" label="采购时间" width="250"></el-table-column>
      <el-table-column :formatter = "recordTypeFormatter" align="left" label="操作" width="150"></el-table-column>
      <el-table-column prop="quantity" align="left" label="采购数量" min-width="150"></el-table-column>
      <el-table-column :formatter="salesType" align="left" label="采购类型" min-width="150"></el-table-column>
      <el-table-column prop="unitPrice" align="left" label="单价" width="150"></el-table-column>
      <el-table-column :formatter="totalFormatter" align="left" label="采购总金额" min-width="150"></el-table-column>
      <el-table-column prop="name" align="left" label="经手人（厂家）" min-width="150"></el-table-column>
    </el-table>

    <el-table
      v-if="tabPosition == 'agent'"
      :data="tableDataAgent"
      class="refundTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="buyerCompanyName" align="left" label="购买单位" min-width="150"></el-table-column>
      <el-table-column :formatter = "dateFormatter" align="left" label="采购时间" width="250"></el-table-column>
      <el-table-column :formatter = "opTypeFormatter" align="left" label="操作" width="150"></el-table-column>
      <el-table-column prop="courseCount" align="left" label="采购数量" min-width="150"></el-table-column>
      <el-table-column :formatter="salesType"  align="left" label="采购类型" min-width="150"></el-table-column>
      <el-table-column prop="unitPrice" align="left" label="单价" width="150"></el-table-column>
      <el-table-column :formatter="totalValueFormatter" align="left" label="采购总金额" min-width="150"></el-table-column>
      <el-table-column prop="sellerUserName" align="left" label="经手人" min-width="150"></el-table-column>
    </el-table>
    <el-table
      v-if="tabPosition == 'station'"
      :data="tableDataStation"
      class="refundTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="buyerCompanyName" align="left" label="购买单位" min-width="150"></el-table-column>
      <el-table-column :formatter = "dateFormatter" align="left" label="采购时间" width="250"></el-table-column>
      <el-table-column :formatter = "opTypeFormatter" align="left" label="操作" width="150"></el-table-column>
      <el-table-column prop="courseCount" align="left" label="采购数量" min-width="150"></el-table-column>
      <el-table-column :formatter="salesType" align="left" label="采购类型" min-width="150"></el-table-column>
      <el-table-column prop="unitPrice" align="left" label="单价" width="150"></el-table-column>
      <el-table-column :formatter="totalValueFormatter" align="left" label="采购总金额" min-width="150"></el-table-column>
      <el-table-column prop="sellerUserName" align="left" label="经手人" min-width="150"></el-table-column>
    </el-table>
    <PagenationContainer v-if="pageCount > 1">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.agentPurchaseHistoryIndex {
  padding-top: 40px;
  
  .targetView {
    float: right;

    .searchLocation {
      float: right;
      display: flex;
      margin-right: 70px;
      margin-top: -20px;
      .line {
        width: 1px;
        height: 40px;
        background-color: #e4e8eb;
        margin-left: 25px;
        margin-right: 25px;
      }
      .saleNumberTitle {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 22px;
      }
      .saleNumber {
        font-size: 20px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 32px;
      }
    }
  }
  .el-input__inner{height:38px}
  .submitBtn{
    background-color: #00c1de;
    border-color: #00c1de;
    color: #fff;
  }
  .statistics {
    float: right;
    margin: 30px 5px 10px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
    .totalResult {
      color: #00c1de;
    }
  }
  .TextGroup {
    margin: 0 20px 0px;
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
    color: #606266;
    .dateRange {
      width: 250px;

      .el-range-editor--mini.el-input__inner {
        height: 32px;
      }

      .el-range-editor.is-active,
      .el-range-editor.is-active:hover {
        border-color: #00c1de;
      }

      .el-date-table td.today span {
        color: #00c1de;
      }
    }
    .dataButton {
      margin-left: 10px;
      display: inline-block;
    }
  }
  .refundTable {
    margin: 20px 1%;
    border: 1px;
    width: 98%;

    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    th > .cell {
      font-weight: bold;
    }

    .cellButtonGroup {
      background-color: #00c1de;
      border-color: #00c1de;
      margin-left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Agent/agentPurchaseHistory.vue